import { fidelityLabel } from '../core/fidelity';
import type { FidelityReport as FidelityReportData } from '../core/types';

export interface FidelityReportProps {
  fidelity: FidelityReportData;
  verificationPassed?: boolean;
  verificationDetails?: string[];
}

export function FidelityReport({ fidelity, verificationPassed, verificationDetails }: FidelityReportProps) {
  return (
    <div className="stack" style={{ gap: 12 }}>
      <div className="row">
        <span className="badge" data-level={fidelity.level}>
          {fidelityLabel(fidelity.level)}
        </span>
        <span className="card-hint">{fidelity.summary}</span>
      </div>

      <div className="fidelity-grid">
        <FidelityLine label="保留" items={fidelity.preserved} tone="ok" />
        <FidelityLine label="改变" items={fidelity.changed} tone="muted" />
        <FidelityLine label="丢失" items={fidelity.unsupported} tone="danger" />
      </div>

      {verificationPassed === false ? (
        <div className="notice" data-tone="danger">
          <span>⛔</span>
          <span>
            <strong>输出校验未通过</strong>
            <br />
            {(verificationDetails ?? ['产物未通过完整性校验']).join('；')}
          </span>
        </div>
      ) : null}

      {verificationPassed === true ? (
        <div className="notice" data-tone="ok">
          <span>✓</span>
          <span>{(verificationDetails ?? ['产物通过校验']).join('；')}</span>
        </div>
      ) : null}
    </div>
  );
}

function FidelityLine({ label, items, tone }: { label: string; items: string[]; tone: 'ok' | 'muted' | 'danger' }) {
  if (items.length === 0) {
    return (
      <div className="fidelity-line">
        <span className="key">{label}</span>
        <span className="card-hint">无</span>
      </div>
    );
  }
  return (
    <div className="fidelity-line">
      <span className="key">{label}</span>
      <span className="row" style={{ flexWrap: 'wrap', gap: 6 }}>
        {items.map((item) => (
          <span key={item} className="badge" data-tone={tone}>
            {item}
          </span>
        ))}
      </span>
    </div>
  );
}
